export default __webpack_public_path__ + "static/media/Union.fb8cd2c7.svg";